import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { CorridorTypeService } from '../proxy/controlling/controllers/corridor-type.service';
import { VehicleTypeService } from '@general/proxy/general/controllers/vehicle-type.service';
FieldBuilder.setNamespace('Controlling');

export const VEHICLETYPETONS_FIELDS: FieldDefinition[] = [
  FieldBuilder.foreignKey('corridorTypeId', 'Entity.CorridorType', CorridorTypeService)
    .displayFromNested('corridorType.name')
    .sortBy('corridorType.name')
    .hideInChildForms()
    .build(),
  FieldBuilder.foreignKey('vehicleTypeId', 'Entity.VehicleType', VehicleTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.date('validity', 'Entity.VehicleTypeTons.Validity')
    .build(),
  FieldBuilder.number('loadTons', 'Entity.VehicleTypeTons.LoadTons')
    .build(),
];

export const VEHICLETYPETONS_CONFIG = {
  entityName: 'VehicleTypeTons',
  localizationKey: 'Controlling::Entity.VehicleTypeTons',
  fields: VEHICLETYPETONS_FIELDS,
  permission: 'ControllingLiquidations.VehicleTypeTonses',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
